module.exports = __webpack_public_path__ + "img/avatar-s-25.96ff7b64.jpg";